export default __webpack_public_path__ + "static/media/products01.a54b5f78.jpg";